import { message, Select, Col, Row, Form as FormInitial, Checkbox, } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  FormItem, ModalItem, ButtonItem, InputItem, SelectItem,
  BoxItem, HeaderItem, Form,
  ErrorItem,
} from "../../../../../../Components/Items";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

class EditarClienteModal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: [],
    objetoColonias: [],
    objetoMunicipios: [],
    objetoEstados: [],
    cliente: null,
    esPersona: false, // Estado para controlar si es persona o empresa
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.consultarDatos();
      // Inicializar correctamente el estado esPersona
      const esPersonaInicial = this.props.cliente ? this.props.cliente.persona : false;
      this.setState({ 
        visible: this.props.visible, 
        cliente: this.props.cliente,
        esPersona: esPersonaInicial
      });
    }
  }

  async consultarDatos() {
    await this.setState({ loading: true });
    
    // Consultar datos necesarios para el formulario
    axios.post("clientes/selectDatosParaCliente", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then(async (res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasRegimenFiscal: res.data.regimenesFiscales,
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => (
              <Option value={value._id} key={value._id}>{value.c_RegimenFiscal + " - " + value.descripcion}</Option>
            )),
            objetoEstados: res.data.estados.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre + " - " + value.abreviatura}</Option>
            )),
          });
          
          // Cargar datos del cliente desde props
          this.cargarDatosCliente();
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.error("Error en la consulta:", error);
        this.setState({ loading: false });
      });
  }

  cargarDatosCliente() {
    const { cliente } = this.props;
    if (!cliente) return;
    
    // Llenar el formulario con los datos del cliente
    this.formRef.current.setFieldsValue({
        nombre: cliente.nombre,
        apellidoPaterno: cliente.apellidoPaterno,
        apellidoMaterno: cliente.apellidoMaterno,
        razonSocial: cliente.razonSocial,
        rfc: cliente.rfc,
        regimenFiscalId: cliente.regimenFiscalId,
        direcciones: cliente.direcciones || [],
        persona: cliente.persona || false,
      });
      

    // Cargar municipios y colonias para cada dirección existente
    if (cliente.direcciones && cliente.direcciones.length > 0) {
      cliente.direcciones.forEach((direccion, index) => {
        if (direccion.estadoId) {
          this.onChangeEstado(direccion.estadoId, index, true);
        }
        if (direccion.municipioId) {
          this.onChangeMunicipio(direccion.municipioId, index, true);
        }
      });
    }
  }

  // Función para manejar el cambio del checkbox "Persona"
  onPersonaChange = (e) => {
    const esPersona = e.target.checked;
    this.setState({ esPersona });
    
    // Limpiar los campos que no se van a usar
    if (esPersona) {
      // Si es persona (empresa), limpiar campos de nombre y apellidos
      this.formRef.current.setFieldsValue({
        nombre: undefined,
        apellidoPaterno: undefined,
        apellidoMaterno: undefined,
      });
    } else {
      // Si no es persona (individuo), limpiar razón social
      this.formRef.current.setFieldsValue({
        razonSocial: undefined,
      });
    }
  };

  onChangeEstado(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === 'undefined') {
        direcciones[fieldKey] = {}
      }
      direcciones[fieldKey].municipioId = undefined;
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
      let objetoColonias = this.state.objetoColonias;
      objetoColonias[fieldKey] = null;
      this.setState({ objetoColonias: objetoColonias });
    }
    axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMunicipios: res.data });
          let objetoMunicipios = this.state.objetoMunicipios;
          objetoMunicipios[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }

  onChangeMunicipio(value, fieldKey, inicial) {
    if (!inicial) {
      let direcciones = this.formRef.current.getFieldValue("direcciones");
      if (typeof direcciones[fieldKey] === 'undefined') {
        direcciones[fieldKey] = {}
      }
      direcciones[fieldKey].coloniaId = undefined;
      this.formRef.current.setFieldsValue({ direcciones: direcciones });
    }
    axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasColonias: res.data });
          let objetoColonias = this.state.objetoColonias;
          objetoColonias[fieldKey] = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            objetoColonias: objetoColonias,
          });
        }
      });
  }

  async onSearchColonia(value, fieldKey, ponerColoniaId) {
    if (value.toString().length === 5) {
      await axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            let direcciones = this.formRef.current.getFieldValue("direcciones");
            if (typeof direcciones[fieldKey] === 'undefined') {
              direcciones[fieldKey] = {}
            }
            if (ponerColoniaId && res.data._id) {
              direcciones[fieldKey].coloniaId = res.data._id
            }
            direcciones[fieldKey].paisId = res.data.paisId
            direcciones[fieldKey].estadoId = res.data.estadoId
            direcciones[fieldKey].municipioId = res.data.municipioId
            this.formRef.current.setFieldsValue({
              direcciones: direcciones,
            });
            this.onChangeEstado(res.data.estadoId, fieldKey, true);
            this.onChangeMunicipio(res.data.municipioId, fieldKey, true);
          }
        });
    }
  }

  async onSelectColoniaId(coloniaId, fieldKey) {
    const direcciones = this.formRef.current.getFieldValue('direcciones')
    if (typeof direcciones[fieldKey] === 'undefined') {
      direcciones[fieldKey] = {}
    }
    if (!direcciones[fieldKey].colonia) {
      const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
      direcciones[fieldKey].colonia = nombreColonia
      await this.formRef.current.setFieldsValue({
        direcciones: direcciones
      })
    }
  }

  

  onFinishFailed = (errorInfo) => {
    ErrorItem(errorInfo)
  };

  onFinish = (values) => {
    this.setState({ loading: true });
  
    const clienteActualizado = {
      ...this.props.cliente,
      ...values,
    };
  
    axios
      .post(
        "clientes/editarCliente",
        {
          ...values,
          empresaId: this.props.empresaId,
          clienteId: this.props.cliente._id, // Se toma directo de props
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
  
        if (res.data.success === 2) {
          message.success("Se ha actualizado el cliente");
  
          // Limpiar formulario y cerrar modal
          this.formRef.current.resetFields();
          this.props.onClienteActualizado(clienteActualizado);
          this.cerrarModal();
        } else if (res.data.success === 1) {
          message.warning(res.data.message || "No se puede actualizar el cliente");
        } else {
          message.error("Hubo un error y el cliente no se actualizó");
        }
        ;
      })
      .catch((error) => {
        console.error("Error al actualizar cliente:", error);
        message.error("Error al actualizar el cliente");
        this.setState({ loading: false });
      });
  };
  
  

  cerrarModal = () => {
    this.setState({ visible: false, esPersona: false });
    this.props.onCancel();
    this.formRef.current.resetFields();
  };

  render() {
    return (
      <ModalItem
        title="Editar Cliente"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal()}
        footer={null}
        width={800}
      >
        <Form
          ref={this.formRef}
          name="EditarClienteModal"
          layout
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          

          <HeaderItem>DATOS EDITABLES</HeaderItem>
          <FormItem
            label="Persona"
            name="persona"
            required
            margin
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            valuePropName="checked"
          >
            <Checkbox 
              onChange={this.onPersonaChange}
            />
          </FormItem>

          {/* Campos para persona física (cuando persona es false) */}
          {!this.state.esPersona && (
            <>
              <FormItem
                label="Nombre"
                name="nombre"
                required
                margin
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputItem placeholder="Nombre del cliente" />
              </FormItem>

              <FormItem
                label="Apellido Paterno"
                name="apellidoPaterno"
                required
                margin
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputItem placeholder="Apellido Paterno" />
              </FormItem>

              <FormItem
                label="Apellido Materno"
                name="apellidoMaterno"
                required
                margin
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputItem placeholder="Apellido Materno" />
              </FormItem>
            </>
          )}

          {/* Campo para persona moral (cuando persona es true) */}
          {this.state.esPersona && (
            <FormItem
              required
              label="Razón Social"
              name="razonSocial"
              margin
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <InputItem placeholder="Razón Social" />
            </FormItem>
          )}
          
          <FormItem
            label="RFC"
            name="rfc"
            required
            margin
            rfc
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <InputItem placeholder="RFC" />
          </FormItem>

          <FormItem
            name="regimenFiscalId"
            label="R. Fiscal"
            margin
            tooltip={{ title: "Campo necesario para facturación" }}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <SelectItem placeholder="Regimen Fiscal">
              {this.state.objetoRegimenFiscal}
            </SelectItem>
          </FormItem>

          <HeaderItem>DIRECCIONES</HeaderItem>
          <FormInitial.List name="direcciones">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                  <div key={key}>
                    {arrayKey === 0 && <HeaderItem>DIRECCION DE FACTURACION</HeaderItem>}
                    {arrayKey === 0 && <p style={{ textAlign: 'center' }}>Campos necesarios para facturación</p>}
                    <Row>
                      <Col span={24}>
                        <HeaderItem>DIRECCION {arrayKey + 1}</HeaderItem>
                        <BoxItem>
                          <Row>
                            <Col span={16} xs={24} sm={24} lg={16} xl={16}>
                              <FormItem
                                {...restField}
                                name={[name, "calle"]}
                                fieldKey={[fieldKey, "calle"]}
                                label="Dirección"
                                max={200}
                                margin
                                pattern
                                labelCol={{ span: 3 }}
                                wrapperCol={{ span: 21 }}
                              >
                                <InputItem
                                  placeholder="Calle"
                                  width="98%"
                                />
                              </FormItem>
                            </Col>
                            <Col span={4} xs={24} sm={24} lg={4} xl={4}>
                              <FormItem
                                {...restField}
                                name={[name, "numeroCalle"]}
                                fieldKey={[fieldKey, "numeroCalle"]}
                                margin
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                              >
                                <InputItem
                                  placeholder="Número"
                                  numeroCalle
                                  width="98%"
                                />
                              </FormItem>
                            </Col>
                            <Col span={4} xs={24} sm={24} lg={4} xl={4}>
                              <FormItem
                                name={[name, "numeroInterior"]}
                                fieldKey={[fieldKey, "numeroInterior"]}
                                margin
                                pattern
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                              >
                                <InputItem
                                  placeholder="Interior"
                                  width="98%"
                                />
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                              <FormItem
                                {...restField}
                                name={[name, "coloniaId"]}
                                fieldKey={[fieldKey, "coloniaId"]}
                                label="C.P."
                                margin
                                required={arrayKey === 0}
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 18 }}
                              >
                                <SelectItem placeholder="Código Postal"
                                  onSearch={(coloniaId) => {
                                    this.onSearchColonia(coloniaId, arrayKey)
                                  }}
                                  onSelect={(coloniaId) => {
                                    this.onSelectColoniaId(coloniaId, arrayKey)
                                  }}
                                >
                                  {!this.state.objetoColonias[
                                    fieldKey
                                  ] ? (
                                    <Option disabled>
                                      Eliga primero un municipio
                                    </Option>
                                  ) : (
                                    this.state.objetoColonias[fieldKey]
                                  )}
                                  <Option disabled>Busque por codigo postal</Option>
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={16} xs={24} sm={24} lg={16} xl={16}>
                              <FormItem
                                {...restField}
                                name={[name, "colonia"]}
                                fieldKey={[fieldKey, "colonia"]}
                                label="Colonia"
                                margin
                                pattern
                                labelCol={{ span: 3 }}
                                wrapperCol={{ span: 21 }}
                              >
                                <InputItem placeholder="Colonia" />
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                              <FormItem
                                {...restField}
                                name={[name, "municipioId"]}
                                fieldKey={[fieldKey, "municipioId"]}
                                margin
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                              >
                                <SelectItem
                                  placeholder="Municipio"
                                  width="98%"
                                  onChange={(e) =>
                                    this.onChangeMunicipio(e, fieldKey)
                                  }
                                >
                                  {!this.state.objetoMunicipios[
                                    fieldKey
                                  ] ? (
                                    <Option disabled>
                                      Eliga primero un estado
                                    </Option>
                                  ) : (
                                    this.state.objetoMunicipios[
                                      fieldKey
                                    ]
                                  )}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                              <FormItem
                                {...restField}
                                name={[name, "estadoId"]}
                                fieldKey={[fieldKey, "estadoId"]}
                                margin
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                              >
                                <SelectItem
                                  placeholder="Estado"
                                  width="98%"
                                  onChange={(e) =>
                                    this.onChangeEstado(e, fieldKey)
                                  }
                                >
                                  {this.state.objetoEstados}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                              <FormItem
                                {...restField}
                                name={[name, "paisId"]}
                                fieldKey={[fieldKey, "paisId"]}
                                margin
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                              >
                                <SelectItem
                                  placeholder="Pais"
                                  width="98%"
                                >
                                  {/* Aquí necesitarías cargar los países si los necesitas */}
                                </SelectItem>
                              </FormItem>
                            </Col>
                          </Row>
                        </BoxItem>
                        <FormItem noStyle>
                          <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
                            <ButtonItem
                              type="primary"
                              danger
                              onClick={() => remove(name)}
                            >
                              Eliminar Dirección
                            </ButtonItem>
                          </div>
                        </FormItem>
                      </Col>
                    </Row>
                  </div>
                ))}
                <FormItem noStyle>
                  <ButtonItem
                    style={{ marginTop: 10, marginBottom: 10 }}
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Agregar Dirección
                  </ButtonItem>
                </FormItem>
              </>
            )}
          </FormInitial.List>

          <FormItem>
            <ButtonItem type="primary" htmlType="submit" loading={this.state.loading}>
              Actualizar
            </ButtonItem>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarClienteModal);